import { render, staticRenderFns } from "./TipoContacto.vue?vue&type=template&id=c4fc6b34&"
import script from "./TipoContacto.vue?vue&type=script&lang=ts&"
export * from "./TipoContacto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports